import {SellerError} from './SellerError.js'

export class GetInstantOfferDetailsNotFoundSellerError extends SellerError {}
